import { render, staticRenderFns } from "./EditCharacteristics.vue?vue&type=template&id=15784c4c&scoped=true"
import script from "./EditCharacteristics.vue?vue&type=script&lang=js"
export * from "./EditCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./EditCharacteristics.vue?vue&type=style&index=0&id=15784c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15784c4c",
  null
  
)

export default component.exports